import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=4a1fb11c&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=4a1fb11c&prod&lang=scss&scoped=true&"
import style1 from "./MessageItem.vue?vue&type=style&index=1&id=4a1fb11c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fb11c",
  null
  
)

export default component.exports